import { useEffect } from "react";

export function clsx(...className) {
  return className.filter((it) => it != null)?.join(" ");
}
export const isArrayEmpty = (arr) => !arr || arr.length === 0;
